import { render, staticRenderFns } from "./PointCreditForm.vue?vue&type=template&id=8575c650"
import script from "./PointCreditForm.vue?vue&type=script&lang=js"
export * from "./PointCreditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports